import { pipe } from '@helo/utils'

import { Options } from '../Options'
import { RenderPipeline } from '../RenderPipeline'
import type { DescriptorInput, DescriptorOutput } from './Descriptor'
import { descriptorOptions } from './Descriptor.options'

/** Resolve title, subtitle, and description from defaults. */
const setupInput = () =>
  RenderPipeline.updateInput(input =>
    pipe(
      input,
      Options.applyDefaults(descriptorOptions),
      Options.validate(descriptorOptions),
    ),
  )

const setDescriptor = () =>
  RenderPipeline.updateOutput(
    (_output: Partial<DescriptorOutput>, ctx: { input: DescriptorInput }) => ({
      title: ctx.input.title,
      subtitle: ctx.input.subtitle,
      description: ctx.input.description,
    }),
  )

export const DescriptorInputParts = {
  setupInput,
}

export const DescriptorOutputParts = {
  setDescriptor,
}
